/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { RequestTypeValueEnum } from '../models/RequestTypeValueEnum';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class EntityHierarchyControllerv2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param studyId
     * @param siteId
     * @param patientId
     * @param requestId
     * @param requestType
     * @returns boolean
     * @throws ApiError
     */
    public entityHierarchyControllerv2Validate(
        studyId?: number | null,
        siteId?: number | null,
        patientId?: number | null,
        requestId?: number | null,
        requestType?: RequestTypeValueEnum | null,
    ): Observable<boolean> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/entity-hierarchy/validate',
            query: {
                'studyId': studyId,
                'siteId': siteId,
                'patientId': patientId,
                'requestId': requestId,
                'requestType': requestType,
            },
        });
    }
}
